import styled from 'styled-components';

const ServerMessage = styled.p`
  margin-bottom: 1rem;
  color: ${({ error }) => (error ? "red" : "green")};
  text-align: center;
`;

export default ServerMessage;